var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotspot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgexport-6_80_",
    "data-name": "svgexport-6 (80)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.759,
    height: 29.261,
    viewBox: "0 0 24.759 29.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M26.682,24.759c0,3.092-6.417,4.5-12.38,4.5s-12.38-1.409-12.38-4.5c0-2.379,3.541-3.5,6.51-4.025a1.126,1.126,0,0,1,.391,2.218c-3.582.629-4.593,1.614-4.651,1.825.172.59,3.549,2.233,10.13,2.233s9.958-1.643,10.131-2.268c-.06-.176-1.077-1.167-4.684-1.794a1.126,1.126,0,0,1,.387-2.218C23.123,21.25,26.682,22.37,26.682,24.759ZM9.8,18.007h1.125v6.752a1.127,1.127,0,0,0,1.126,1.125h4.5a1.128,1.128,0,0,0,1.126-1.125V18.007H18.8a1.128,1.128,0,0,0,1.126-1.126V10.129a2.753,2.753,0,0,0-2.472-2.022A19.8,19.8,0,0,0,14.32,7.9a20.134,20.134,0,0,0-3.174.211,2.756,2.756,0,0,0-2.471,2.022v6.752A1.128,1.128,0,0,0,9.8,18.007ZM14.3,6.752a3.376,3.376,0,1,0-3.377-3.376A3.377,3.377,0,0,0,14.3,6.752Z",
    transform: "translate(-1.923 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotspot);
export default __webpack_public_path__ + "static/media/hotspot.9fbabd5b81b57d9e0475e123f89ab84d.svg";
export { ForwardRef as ReactComponent };